module.exports = __webpack_public_path__ + "img/icon2.1ed83e3a.png";